<template>
  <pt-notice-manage class="pt-notice-manage__withData"></pt-notice-manage>
</template>

<script>
import PtNoticeManage from './index'
export default {
  name: 'pt-notice-manage__withData',
  components: {
    'pt-notice-manage': PtNoticeManage
  }
}
</script>
